var deDE = {
	"codeBlock.copied": "Kopiert",
	"codeBlock.copyLabel": "Kopieren",
	"inlineCodeBlock.copied": "Kopiert",
	"inlineCodeBlock.copyLabel": "Inline-Code kopieren"
};

export { deDE as default };
